<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            flat
            color="transparent">
            <v-card-text>
              <v-skeleton-loader
                :loading="process.load"
                type="list-item-avatar-three-line, article, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, article">
                <div>
                  <div v-if="!process.load && Object.keys(detail).length > 0">
                    <v-card
                      flat
                      color="transparent"
                      class="py-0"
                      style="border-radius: 10px;">
                      <v-list
                        flat
                        dense
                        color="transparent">
                        <v-list-item
                          @click="sheet.images = true; images = detail.tanaman_image;"
                          class="px-0">
                          <v-list-item-avatar
                            tile
                            size="50"
                            style="border: 2px solid #ffffff; border-radius: 8px !important;">
                            <v-img
                              width="100%"
                              height="100%"
                              alt="diskominfo"
                              :src="detail.tanaman_image.length > 0 ? detail.tanaman_image[0].file_url : require('@/assets/image/image_default.png')"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular
                                    size="20"
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title
                              class="title font-weight-bold text-capitalize line-text-second">
                              {{ detail.tanaman_title }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card>

                    <v-divider
                      class="my-1"
                      style="border-top: 1px dashed #bbb;" />

                    <div
                      class="d-flex align-center my-4">
                      <div>
                        <div
                          class="font-weight-bold line-text-second text-capitalize">
                          {{ detail.tanaman_create_datetime | datetime }}
                        </div>
                      </div>

                      <v-spacer />

                      <v-chip
                        small
                        class="white--text text-capitalize"
                        :color="detail.tanaman_status === 'publish' ? 'green' : 'red'">
                        {{ detail.tanaman_status }}
                      </v-chip>
                    </div>

                    <v-divider
                      class="my-1"
                      style="border-top: 1px dashed #bbb;" />

                    <div
                      class="font-weight-bold mt-4">
                      Klasifikasi Ilmiah
                    </div>

                    <v-row>
                      <v-col
                        v-for="(item, index) in detail.tanaman_klasifikasi_data"
                        :key="index"
                        cols="12">
                        <div
                          class="d-flex align-center">
                          <v-icon size="18" :color="set_color">mdi-leaf</v-icon>

                          <span
                            class="ml-1">
                            {{ item.cat_title }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>

                    <v-divider
                      class="my-1"
                      style="border-top: 1px dashed #bbb;" />

                    <div
                      class="mt-4 mb-2">
                      <div
                        class="font-weight-bold">
                        Binomial
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.tanaman_content.nama_binomial !== '' ? detail.tanaman_content.nama_binomial : 'Tidak diketahui' }}
                      </div>
                    </div>

                    <div
                      class="my-2">
                      <div
                        class="font-weight-bold">
                        Umum
                      </div>

                      <v-spacer />

                      <div
                        class="line-text-second">
                        {{ detail.tanaman_content.nama_umum !== '' ? detail.tanaman_content.nama_umum : 'Tidak diketahui' }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="font-weight-bold">
                        Ciri-ciri
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.tanaman_content.ciri !== '' ? detail.tanaman_content.ciri : 'Tidak diketahui' }}
                      </div>
                    </div>

                    <v-divider
                      class="my-1"
                      style="border-top: 1px dashed #bbb;" />

                    <div>
                      <div
                        class="font-weight-bold mt-4 mb-2">
                        Manfaat
                      </div>

                      <div
                        class="line-text-second mb-4">
                        {{ detail.tanaman_content.manfaat !== '' ? detail.tanaman_content.manfaat : 'Tidak diketahui' }}
                      </div>
                    </div>

                    <v-divider
                      class="my-1"
                      style="border-top: 1px dashed #bbb;" />

                    <div>
                      <div
                        class="font-weight-bold mt-4 mb-2">
                        Referensi
                      </div>

                      <div
                        class="line-text-second mb-4">
                        {{ detail.tanaman_content.referensi !== '' ? detail.tanaman_content.referensi : 'Tidak diketahui' }}
                      </div>
                    </div>

                    <v-divider
                      class="my-1"
                      style="border-top: 1px dashed #bbb;" />

                    <div
                      class="font-weight-bold mt-4 mb-2">
                      Klimatologi
                    </div>

                    <div
                      class="d-flex align-center mb-2">
                      <div>
                        Ketinggian Lokasi Optimal
                      </div>

                      <v-spacer />

                      <div
                        class="text-capitalize">
                        {{ detail.tanaman_content.ketinggian !== '' ? detail.tanaman_content.ketinggian : 'Tidak diketahui' }} Mdpl
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-2">
                      <div>
                        Suhu Optimal
                      </div>

                      <v-spacer />

                      <div
                        class="text-capitalize">
                        {{ detail.tanaman_content.suhu !== '' ? detail.tanaman_content.suhu : 'Tidak diketahui' }} °C
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-2">
                      <div>
                        Kebutuhan Penyinaran
                      </div>

                      <v-spacer />

                      <div
                        class="text-capitalize d-flex align-center">
                        <!-- {{ detail.tanaman_content.sinar !== '' ? detail.tanaman_content.sinar : 'Tidak diketahui' }} % -->

                        <v-avatar
                          size="24">
                          <v-img
                            contain
                            width="100%"
                            height="100%"
                            alt="ensiklopediatanaman"
                            :src="
                              detail.tanaman_content.sinar == 'cahaya_penuh_langsung' ||
                              detail.tanaman_content.sinar == 'semi_naungan' ||
                              detail.tanaman_content.sinar == 'naungan' ?
                              require(`@/assets/icon/klimatologi/${detail.tanaman_content.sinar}.png`) :
                              require('@/assets/logo/favicon.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>

                        <span>
                          {{
                            detail.tanaman_content.sinar == 'cahaya_penuh_langsung' ? 'Cahaya Penuh Langsung' :
                            detail.tanaman_content.sinar == 'semi_naungan' ? 'Semi Naungan' : 'Naungan'
                          }}
                        </span>
                      </div>
                    </div>

                    <div
                      class="d-flex align-center mb-2">
                      <div>
                        Kebutuhan Air
                      </div>

                      <v-spacer />

                      <div
                        class="text-capitalize d-flex align-center">
                        <!-- {{ detail.tanaman_content.air !== '' ? detail.tanaman_content.air : 'Tidak diketahui' }} M3 -->

                        <v-avatar
                          size="24">
                          <v-img
                            contain
                            width="100%"
                            height="100%"
                            alt="ensiklopediatanaman"
                            :src="
                              detail.tanaman_content.air == 'sedikit' ||
                              detail.tanaman_content.air == 'sedang' ||
                              detail.tanaman_content.air == 'banyak' ?
                              require(`@/assets/icon/klimatologi/${detail.tanaman_content.air}.png`) :
                              require('@/assets/logo/favicon.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>

                        <span>
                          {{
                            detail.tanaman_content.air == 'sedikit' ? 'Sedikit' :
                            detail.tanaman_content.air == 'sedang' ? 'Sedang' : 'Banyak'
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-skeleton-loader>
            </v-card-text>
          </v-card>
        </section>

        <v-bottom-sheet
          v-model="sheet.images"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card v-if="Object.keys(detail).length > 0"
            flat
            class="background">
            <div
              class="blur">
              <v-card-title
                class="pa-4"
                style="border-radius: 0px 0px 15px 15px;
                      position: absolute;
                      width: 100%;
                      z-index: 2;
                      background: #d7e2c5;
                      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px !important;">
                <v-icon
                  @click="sheet.images = false; images = {};"
                  :color="set_color"
                  class="cursor-pointer ">
                  mdi-arrow-left-thick
                </v-icon>

                <span
                  @click="sheet.images = false; images = {};"
                  class="body-1 font-weight-bold text-capitalize cursor-pointer ml-1"
                  style="opacity: 70%;">
                  Gambar {{ detail.tanaman_title }}
                </span>
              </v-card-title>

              <v-card-text
                class="mt-16"
                style="height:calc(100vh - 140px); overflow: auto;">
                <v-row>
                  <v-col
                    v-for="(item, index) in images"
                    :key="index"
                    cols="6">
                    <v-card
                      @click="sheet.zoom_images = true; zoom_images = item;"
                      flat
                      color="#d7e2c540"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea;
                            border-style: dashed;
                            box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;">
                      <v-img
                        contain
                        width="100%"
                        height="250"
                        alt="diskominfo"
                        :src="item.file_url.length > 0 ? item.file_url : require('@/assets/image/image_default.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular
                              size="20"
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>

                        <v-card
                          flat
                          color="#00000060"
                          class="pa-3 white--text font-weight-bold"
                          style="position: absolute; width: 100%; bottom: 0;">
                          {{ item.title ? item.title : 'Tidak ada jenis' }}
                        </v-card>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet
          v-model="sheet.zoom_images"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card v-if="Object.keys(detail).length > 0"
            flat
            class="background">
            <div
              class="blur">
              <v-card-title
                class="pa-4"
                style="border-radius: 0px 0px 15px 15px;
                      position: absolute;
                      width: 100%;
                      z-index: 2;
                      background: #d7e2c5;
                      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px !important;">
                <v-icon
                  @click="sheet.zoom_images = false; zoom_images = {};"
                  :color="set_color"
                  class="cursor-pointer ">
                  mdi-arrow-left-thick
                </v-icon>

                <span
                  @click="sheet.zoom_images = false; zoom_images = {};"
                  class="body-1 font-weight-bold text-capitalize cursor-pointer ml-1"
                  style="opacity: 70%;">
                  Perbesar Gambar {{ detail.tanaman_title }}
                </span>
              </v-card-title>

              <v-card-text
                class="mt-16"
                style="height:calc(100vh - 140px); overflow: auto;">
                <v-row>
                  <v-col>
                    <v-card
                      flat
                      color="transparent"
                      style="border-radius: 15px;">
                      <v-img
                        width="100%"
                        height="100%"
                        alt="diskominfo"
                        :src="Object.keys(zoom_images).length > 0 ? zoom_images.file_url : require('@/assets/image/image_default.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular
                              size="20"
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>

                    <div v-if="Object.keys(zoom_images).length > 0"
                      class="mt-6">
                      Jenis: <strong>{{ zoom_images.title ? zoom_images.title : 'Tidak ada jenis' }}</strong>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </div>
          </v-card>
        </v-bottom-sheet>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { createSEOMeta } from '@/utils/seo'
  export default {
    middleware: false,
    data () {
      return {
        sheet: {
          images: false,

          zoom_images: false
        },

        images: {},
        zoom_images: {},

        detail: {},
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        },
        // SEO
        content: {
          url: '/tanaman/:slug',
          title: 'Tanaman',
          description: 'Tanaman Ensiklopedia Tanaman',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    components: {

    },
    watch: {

    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.member.auth.user
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.header.config.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          slug: this.$route.params.slug
        }

        await this.$axios.$get(`${process.env.API}tanaman/detail`, { params })
        .then((response) => {
          this.process.load = false

          if (response.code === 200) {
            this.detail = response.data
          }
        })
      }
    }
  }
</script>
